import { Disclosure } from '@web-app/components/Disclosure/Disclosure';
import { FC } from 'react';

export interface JournalActivityDisclosureProps {
  count: number;
  hasMore: boolean;
  onClick?: () => void;
}

/**
 * Disclosure row showing the number of journal entries since the last appointment.
 * Shown in the Session Prep tab when there are entries to highlight.
 */
export const JournalActivityDisclosure: FC<JournalActivityDisclosureProps> = ({
  count,
  hasMore,
  onClick,
}) => {
  if (count === 0) {
    return null;
  }

  const countLabel = hasMore ? `${count}+` : `${count}`;
  const entryWord = count === 1 && !hasMore ? 'entry' : 'entries';
  const text = `${countLabel} journal ${entryWord} since the last appointment`;

  return (
    <Disclosure
      variant="success"
      text={text}
      onClick={onClick}
      data-testid="journal-activity-disclosure"
    />
  );
};

JournalActivityDisclosure.displayName = 'JournalActivityDisclosure';
